import React, { useMemo } from "react";
import FeatherIcon from "feather-icons-react";
import { useTranslation } from "react-i18next";
import SelectInput from "../../../components/SelectInput"; // Убедитесь, что путь до вашего SelectInput правильный
import { formatDateDDMM, getWeekdayShort } from "../../../constants";

const StageSelector = ({ stages, activeStage, onStageChange, children, chevron=false }) => {
    const { t, i18n } = useTranslation();

    // Трансформируем данные стадий в формат {id, name}, который ожидает SelectInput
    const formattedStages = useMemo(() => {
        return stages.map((stage, index) => {
            // Универсальная поддержка: title (табы сеток), name (этапы), date (расписание)
            const itemName = stage.title || stage.name || (stage.date
                ? `${formatDateDDMM(stage.date)} ${getWeekdayShort(stage.date, i18n.language)}`
                : `${t("Stage")} ${index + 1}`);
            return {
                id: stage.id,
                name: itemName
            };
        });
    }, [stages, t, i18n.language]);

    // Находим индексы для стрелочек
    const activeIndex = stages.findIndex(s => s.id === activeStage);

    const activeStageName = activeIndex !== -1 && formattedStages[activeIndex]
        ? formattedStages[activeIndex].name
        : t("Select");

    const handlePrev = (e) => {
        e.preventDefault();
        if (activeIndex > 0) onStageChange(stages[activeIndex - 1].id);
    };

    const handleNext = (e) => {
        e.preventDefault();
        if (activeIndex >= 0 && activeIndex < stages.length - 1) onStageChange(stages[activeIndex + 1].id);
    };

    // Если стадий 1 или 0, просто рендерим вкладки с children (кнопками), без селектора
    if (stages.length === 0) {
        return <>{children}</>;
    }


    return (
        <>
            {
                chevron &&
                <li>
                    <a
                        href="#"
                        onClick={handlePrev}
                        className="chevron-btn1"
                    >
                        <FeatherIcon icon="chevron-left" />
                    </a>
                </li>
            }
            <li>
                <div className="stage-selector">
                    <div className="stage-absolute-block">
                        <SelectInput
                            data={formattedStages}
                            default_text={activeStageName}
                            default_value={activeStage}
                            setInputValue={onStageChange}
                            input_name="stage_select"
                            show_label={false} // Нам тут не нужен label
                            background={true}  // Белый фон
                            search={stages.length > 10} // Автоматически включаем поиск, если стадий больше 10 (очень удобно!)
                        />
                    </div>
                </div>
            </li>
            {
                chevron &&
                <li>
                    <a
                        href="#"
                        onClick={handleNext}
                        className="chevron-btn1"
                    >
                        <FeatherIcon icon="chevron-right" />
                    </a>
                </li>
            }

            {/* Рендерим любые дополнительные кнопки (например кнопку "Matches view") */}
            {children}
        </>
    );
};

export default StageSelector;